import LoadingButton from '@atlaskit/button/loading-button';
import Button from '@atlaskit/button/standard-button';
import { useFlags } from '@atlaskit/flag';
import ModalDialog, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { getFlagForError } from '@atlassian/developer-space';
import { archivePartner } from '@atlassian/mpac-api-client';
import { showModalIfTwoSVSessionExpires, useTwoStepAuthTimedOut } from '@atlassian/mpac-ui';
import { archivePartnerLink, log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
export const ArchivePartnerButtonStyle = {
  lineHeight: '40px',
  height: '40px',
  marginLeft: '10px'
};
const ArchivePartner = props => {
  const {
    showFlag
  } = useFlags();
  const [isArchivePartnerModalOpen, setArchivePartnerModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    setTwoStepAuthTimedOut
  } = useTwoStepAuthTimedOut();
  const handleOpenModal = () => setArchivePartnerModalOpen(true);
  const handleCloseModal = () => setArchivePartnerModalOpen(false);
  const handleArchivePartner = async () => {
    setIsLoading(true);
    try {
      const isArchived = await archivePartner(props.mpacBaseUrl, props.partnerId);
      if (isArchived) {
        handleCloseModal();
        window.location.href = archivePartnerLink().expand({
          partnerId: props.partnerId
        });
      }
    } catch (error) {
      showModalIfTwoSVSessionExpires(error, setTwoStepAuthTimedOut);
      showFlag(getFlagForError('archive-partner-flag', 'Archiving this vendor failed'));
      log.error('PartnerActions/ArchivePartner', "Failed to archive partner", {
        error
      });
    }
    setIsLoading(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    style: ArchivePartnerButtonStyle,
    onClick: handleOpenModal
  }, "Archive vendor"), isArchivePartnerModalOpen && /*#__PURE__*/React.createElement(ModalDialog, {
    onClose: handleCloseModal
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitle, null, "Archive vendor")), /*#__PURE__*/React.createElement(ModalBody, null, "This will archive all of ", props.partnerName, "'s apps. Are you sure?"), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(LoadingButton, {
    appearance: "subtle",
    isLoading: isLoading,
    onClick: handleArchivePartner
  }, "Ok"), /*#__PURE__*/React.createElement(Button, {
    onClick: handleCloseModal
  }, "Cancel"))));
};
export default ArchivePartner;